<template>
  <div class="bg-gray">
    <div class="container-fluid">
      <div class="user-card">
        <h2>Playlists</h2>

        <table class="table table-striped">
          <thead>
            <tr>
              <th>User</th>
              <th>Name</th>
              <th>URL</th>
              <th>Approved</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
          <tr
               v-for="(result, index) in results" :key="index"
          >
            <td>
              <router-link v-if="result.user" :to="`/users/${result.user.id}`">{{result.user.firstName}} {{result.user.lastName}} ({{result.user.username}})</router-link>
            </td>
            <td>{{result.name}}</td>
            <td>
              <a target="_blank" :href="result.url">{{result.url}}</a>
            </td>

            <td>{{result.approved ? 'Yes' : 'No'}}</td>
            <td>
              <template>
                <button  @click="update(result.id,  true)" class="btn btn-default" style="margin-right: 10px;">Approve</button>
                <button  @click="update(result.id,false)" class="btn btn-danger">Reject</button>
              </template>
            </td>
          </tr>
          </tbody>
        </table>


      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { StoreActions } from "./store/actions";
import StoreIndex from "./store/_StoreIndex";
import {StoreState as state} from './store/state'

export default {
  name: "ReportedUsers",
  components: {
  },
  data() {
    return {
      suspendConfirm: false
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.dispatch(StoreActions.search);
    },
    commit(path, value) {
      this.$store.commit(`${StoreIndex.path}/${path}`, value);
    },
    dispatch(path, value) {
      this.$store.dispatch(`${StoreIndex.path}/${path}`, value);
    },
    update(id, approve) {
      this.dispatch(StoreActions.update, {
        id: id,
        approved: approve
      })
    }
  },
  computed: {
    ...mapState(StoreIndex.path,[
        state.results,
        state.page
    ])
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-header {
  background: #46c3f0;
  color: white;
}
a {
  color: black;
  font-weight: bold;
}

.btn-secondary {
  background: lightgray;
  border-color: lightgray;
}

@media (max-width: 700px) {
  .mobile-hide {
    display: none;
  }
}

@media (min-width: 701px) {
  .large-hide {
    display: none;
  }
}

.user-card {
  background: white;
  margin: 20px;
  border-radius: 10px;
}

.user-img {
  border-radius: 10px;
  margin: 10px;
}

label {
  color: gray;
  font-weight: bold;
}

.user-photo {
  width:100px;
  height:100px;
  border-radius: 50px;
  object-fit: cover;
}

@media (max-width:767px) {
  .user-photo {
    width: 50px;
    height: 50px;
    border-radius: 25px;
  }
}
</style>